<template>
    <!-- {{ dataObj }} -->

    <b-row>
        <div class="black-card">

            <b-row class="py-2">
                <b-col lg="5" md="2" sm="6" cols="12">
                    <p class="grey-label">{{ $t('blackboxInfo.Purchaserate') }}</p>
                </b-col>
                <b-col lg="7" md="10" sm="6" cols="12">
                    <p class="white-filed">₹ {{ dataObj.PurchasePrice }}</p>
                </b-col>
            </b-row>
            <b-row class="py-2">
                <b-col lg="5" md="2" sm="6" cols="12">
                    <p class="grey-label">{{ $t('blackboxInfo.mrp') }}</p>
                </b-col>
                <b-col lg="7" md="10" sm="6" cols="12">
                    <p class="white-filed">₹ {{ dataObj.MRP }}</p>
                </b-col>
            </b-row>
            <!-- <b-row class="py-2">
                <b-col lg="5" md="2" sm="6" cols="12">
                    <p class="grey-label">{{ $t('blackboxInfo.quality') }}</p>
                </b-col>
                <b-col lg="7" md="10" sm="6" cols="12">
                    <p class="white-filed">5,454</p>
                </b-col>
            </b-row> -->
        </div>
    </b-row>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        dataObj: {
            type: Object,
            default: {}
        }
    },
    setup() {
        return {
        }
    }
})
</script>
<style lang="scss" scoped>
.black-card {

    margin-top: 20px;
    margin-bottom: 30px;
    background-color: #161B22;
    border-radius: 15px;

    padding: 20px;
}

.grey-label {
    text-align: left;
    color: #999999;
    font-size: 14px;
}

.white-filed {
    text-align: right;
    color: #FFFFFF;
    font-size: 14px;
}
</style>